import { RefObject, Dispatch, SetStateAction } from 'react'
import { Table as TanstackTable, SortingState } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'
import { Table, TableLoadingOverlay } from '@/components'
import { useTableSorting } from '@/hooks'

type TotalEmissionsTableProps = {
    table: TanstackTable<unknown>
    isLoading: boolean
    sorting: SortingState
    setSorting: Dispatch<SetStateAction<SortingState>>
    summaryCells?: React.ReactNode[]
    containerRef?: RefObject<HTMLDivElement>
    tableBodyRef?: RefObject<HTMLTableSectionElement>
    tableWrapperRef?: RefObject<HTMLDivElement>
    tableRef?: RefObject<HTMLTableElement>
}

export const TotalEmissionsTable: React.FC<TotalEmissionsTableProps> = (
    props
) => {
    const {
        table,
        isLoading,
        setSorting,
        summaryCells,
        containerRef,
        tableBodyRef,
        tableWrapperRef,
        tableRef,
    } = props

    const { t } = useTranslation('translations')
    const loadingTitle = t('analytics.common.report_table_loading')

    const { onTableColumnHeaderClick, getTableColumnSorting } = useTableSorting(
        table,
        setSorting
    )

    return (
        <div className="relative h-full" ref={containerRef}>
            {summaryCells && (
                <Table
                    table={table}
                    style="table"
                    tableWrapperRef={tableWrapperRef}
                    tableBodyRef={tableBodyRef}
                    tableRef={tableRef}
                    onTableColumnHeaderClick={onTableColumnHeaderClick}
                    getColumnSorting={getTableColumnSorting}
                    summary={{ cells: summaryCells }}
                />
            )}
            <TableLoadingOverlay show={isLoading} title={loadingTitle} />
        </div>
    )
}
